module.exports = __webpack_public_path__ + "view/parameters.html";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]&outputPath=view/!./src/view/parameters.html
// module id = 27
// module chunks = 0